import { detect } from 'detect-browser';
import * as React from 'react';
import styled from 'styled-components';
import { createVideoUrl } from '../../../cloudinary';
import Button from '../../../components/Button';
import RecordPage from '../../../components/RecordPage';
import UploadVideo from '../../../components/UploadVideo';

interface VideoProps {
    vacancyId: string;
    videoReference: string | null;
    onNewVideo: (publicId: string) => void;
}

interface VideoState {
    showRecording: boolean;
}

const VideoFrame = styled.div`
    margin-bottom: 1rem;
`;

class HiringManagerVideoBox extends React.Component<VideoProps, VideoState> {
    public constructor(props) {
        super(props);
        this.handleRetry = this.handleRetry.bind(this);
        this.handleNewVideoUpload = this.handleNewVideoUpload.bind(this);
        this.state = { showRecording: props.video === null };
    }

    private handleRetry() {
        this.setState({ showRecording: true });
    }

    private handleNewVideoUpload(publicId: string) {
        this.props.onNewVideo(publicId);
    }

    public render() {
        const supportedBrowsers = ['firefox', 'chrome', 'opera'];
        const isRecordingSupported = supportedBrowsers.indexOf(detect().name) > -1;
        const answerVideoLink = createVideoUrl(this.props.videoReference!);
        return (
            <div>
                {this.state.showRecording ? (
                    isRecordingSupported ? (
                        <RecordPage
                            tags="vacancy_video"
                            folder={'vacancy/' + this.props.vacancyId}
                            onNewVideoUpload={this.handleNewVideoUpload}
                        />
                    ) : (
                        <UploadVideo
                            tags="vacancy_video"
                            folder={'vacancy/' + this.props.vacancyId}
                            onNewVideoUpload={this.handleNewVideoUpload}
                        />
                    )
                ) : (
                    <div>
                        <VideoFrame>
                            <video key={answerVideoLink} controls={true} autoPlay={false} width="100%">
                                <source src={answerVideoLink} type="video/mp4" />
                            </video>
                        </VideoFrame>
                        <Button onClick={this.handleRetry}>Make new recording</Button>
                    </div>
                )}
            </div>
        );
    }
}

export default HiringManagerVideoBox;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/components/HiringManagerVideoBox.tsx